// Launch Darkly Keys for Order Solution
var FF_FULFILLMENT_TYPE_CURBSIDE = "FF-FULFILLMENT-TYPE-CURBSIDE";
var FF_FULFILLMENT_TYPE_DELIVERY = "FF-FULFILLMENT-TYPE-DELIVERY";
var FF_SHOW_FAVORITES = "FF-SHOW-FAVORITES";
var FF_VANITY_CODE_ENABLED = "FF-VANITY-CODE-ENABLED";
var FF_BEST_SELLERS_ENABLED = "FF_BEST_SELLERS_ENABLED";
var FF_MAINTENANCE_PAGE_REDIRECT = "FF-MAINTENANCE_PAGE_REDIRECT";
var FF_ENABLE_CUSTOM_BANNER = "FF-ENABLE-CUSTOM-BANNER";
var FF_COMBOS_BEFORE_AND_AFTER_PRICING = "FF-COMBOS_BEFORE_AND_AFTER_PRICING";

var FF_LOYALTY_MIGRATION = "FF-LOYALTY-MIGRATION";

var FF_FOOTLONG_DOUBLE_PROTEIN = "FF_FOOTLONG_DOUBLE_PROTEIN";
var FF_NEW_GIFTCARD_FORMAT = "FF-GIFT_CARD_PROVIDER";

var FF_ENABLE_UTENSILS = "FF_ENABLE_UTENSILS";
var FF_ENABLE_NONSDOFFERS = "FF-NONSD-CARDS";
var FF_ENABLE_SUBWAYMERCH = "FF-SUBWAYMERCH-CARD";
var FF_ENABLE_GIFTCARD = "FF-SHOW-GIFT-CARD";
var FF_APPLE_PAY_PAYMENT_METHOD_WEB = "FF-APPLE_PAY_PAYMENT_METHOD_WEB";
var FF_GOOGLE_PAY_PAYMENT_METHOD_WEB = "FF-GOOGLE_PAY_PAYMENT_METHOD_WEB";
var FF_FREEDOM_PAY = "FF_FREEDOM_PAY";
var FF_ATH_MOVIL = "FF_ATH_MOVIL";
var FF_FULFILLMENT_TYPE_CATERING = "FF-FULFILLMENT_TYPE_CATERING";
var FF_ENABLE_GIFT_CARD_RELOAD_WITH_SVS = "FF_ENABLE_GIFT_CARD_RELOAD_WITH_SVS";
var FF_PROMOTION_HAPPY_GILMORE = "FF_PROMOTION_HAPPYGILMORE";
var FF_DRIVE_THRU = "FF-DRIVE-THRU";
var FF_SHOW_GUEST_UPSELL = "FF_SHOW-GUEST-UPSELL";
var FF_ACCOUNT_UNAVAILABLE_BANNER = "FF-ACCOUNT-UNAVAILABLE-BANNER";
var FF_SIGN_IN = "FF_SIGN-IN";
var FF_SHOW_CJA = "FF_SHOW_CJA"; // Check for CJA flag --> [FF-SHOW-CJA]
var FF_STRIKE_THROUGH_PRICING = "FF_STRIKE_THROUGH_PRICING";
var currentEnvID = $("#ldEnvKey").val(); // Get the current environment id from Web.config
var defaultEnvId = "62865413a65084143bda68a9";
var client;
var launchdarkly;

// Here we initialize the LaunchDarkly client connection.
function InitilizeLD() {
  if (client) {
    client.close();
  }

  var envId = currentEnvID || defaultEnvId;
  var context = constructUserObject();
  client = LDClient.initialize(envId, context);
  client.waitUntilReady().then(() => {
    client.on("change", function (allChanges) {
      let LDKey = Object.keys(allChanges)[0];
      if (LDKey == FF_MAINTENANCE_PAGE_REDIRECT)
        launchdarkly.ShowMaintenancePage(allChanges);
      if (LDKey == FF_SHOW_FAVORITES) launchdarkly.HideFavorites(allChanges);
      if (LDKey == FF_VANITY_CODE_ENABLED)
        launchdarkly.HideVanityCode(allChanges);
      if (LDKey == FF_BEST_SELLERS_ENABLED)
        launchdarkly.HideBestSellers(allChanges);
      if (LDKey == FF_ENABLE_CUSTOM_BANNER)
        launchdarkly.ShowCustomBanner(allChanges);
      if (LDKey == FF_LOYALTY_MIGRATION)
        launchdarkly.HideRewardsAndDeals(allChanges);
      if (LDKey == FF_FULFILLMENT_TYPE_DELIVERY)
        launchdarkly.HideFullfillmentTypeDelivery(allChanges);
      if (LDKey == FF_FULFILLMENT_TYPE_CATERING)
        launchdarkly.HideCateringCtaDashboard(allChanges);
      if (LDKey == FF_SIGN_IN)
        launchdarkly.handleJoinNowToggle(allChanges);
      if (LDKey == FF_SHOW_CJA)
        launchdarkly.toggle_CJA(allChanges);
      if(LDKey == FF_STRIKE_THROUGH_PRICING)
        launchdarkly.strikeThrough(allChanges);
    });
    client.waitForInitialization().then(function () {
      launchdarkly.HideFavorites();
      launchdarkly.HideBestSellers();
      launchdarkly.ShowMaintenancePage();
      launchdarkly.ShowCustomBanner();
      launchdarkly.HideRewardsAndDeals();
      launchdarkly.HideVanityCode();
      launchdarkly.HideCateringCtaDashboard();
      launchdarkly.handleJoinNowToggle();
      launchdarkly.toggle_CJA();
      launchdarkly.strikeThrough();
    });
  });
}

// Here we build a user object from the form fields.
// https://docs.launchdarkly.com/home/users/built-in-attributes
// https://docs.launchdarkly.com/home/users/custom-attributes/?q=user
function constructUserObject() {
  let context = {
    kind: "user",
    key: "subway-WEB_" + $("#scLanguageCode").val().toLowerCase(),
    country: $("#scLanguageCode").val().slice(-2).toLowerCase(),
    culture: $("#scLanguageCode").val().toLowerCase(),
  };

  void 0;
  return context;
}

/*  NEW LD FLAG FUNCTION TEMPLATE
 
    Check for (Flag Type) Flag --> [Flag key]
    function Show(FlagType)() {
        var (FlagType)Flag = client.variation("[Flag key]", false);
        // Flag Logic
    }
 
    Documentation: https://docs.launchdarkly.com/sdk/features
 
*/

var LaunchDarkly = function () {
  // Check for Fullfillment Type Curbside flag --> [FF-FULFILLMENT-TYPE-CURBSIDE]
  this.HideFullfillmentTypeCurbside = function (changes) {
    let fullfillmentTypeCurbsideFlag = client.variation(
      FF_FULFILLMENT_TYPE_CURBSIDE,
      false
    );
  };

  // Check for Fullfillment Type Delivery flag --> [FF-FULFILLMENT-TYPE-DELIVERY]
  this.HideFullfillmentTypeDelivery = function (changes) {
    let fullfillmentTypeDeliveryFlag = client.variation(
      FF_FULFILLMENT_TYPE_DELIVERY,
      true
    );
    let baseUrl = window.location.origin + "/";
    let languageCode = $("#scLanguageCode").val();
    let deliveryLocatorPageUrl = baseUrl + languageCode + "/deliverylocator";
    let locatorPageUrl = baseUrl + languageCode + "/locator";
    const pickupSelectButton = document.querySelector(".pickupSelectButton");

    if (!fullfillmentTypeDeliveryFlag) {
      $(".deliverySelectButton").hide();
      pickupSelectButton.style.setProperty("width", "100%", "important");
      if (window.location.href == deliveryLocatorPageUrl)
        location.assign(locatorPageUrl);
    }
    else {
      $(".deliverySelectButton").show();
      pickupSelectButton.style.setProperty("width", "49%");
    }
  };

  // Check for Maintenance Page Flag --> [FF_MAINTENANCE_PAGE_REDIRECT]
  this.ShowMaintenancePage = function (changes) {
    let maintenancePageData = client.variation(
      FF_MAINTENANCE_PAGE_REDIRECT,
      false
    );
    let webDownFlag =
      maintenancePageData.bodyWebDown || maintenancePageData.footerWebDown;
    let channelsDownFlag =
      maintenancePageData.bodyChannelsDown ||
      maintenancePageData.footerChannelsDown;
    let forceCheckout = maintenancePageData.forceLogout;

    let baseUrl = window.location.origin + "/";
    let languageCode = $("#scLanguageCode").val();
    let maintenancePageUrl = `${baseUrl}maintenance.aspx?culture=${languageCode}&status=${webDownFlag ? "web" : "channels"
      }&forceCheckout=${forceCheckout ? maintenancePageData.forceLogout : false
      } `;

    // if the maintenance page flag is false (off) redirect user back homepage
    if (
      maintenancePageData.maintenancePageFlag === false &&
      window.location.pathname === "/maintenance.aspx"
    ) {
      if (languageCode === "" || languageCode === undefined)
        location.replace(baseUrl);
      else location.replace(baseUrl + languageCode);
    }

    // in the case that LD flag is changed from web to channels and vice versa while on maintenance page
    else if (window.location.pathname === "/maintenance.aspx" && changes) {
      maintenancePageUrl = `${baseUrl}maintenance.aspx?culture=${languageCode}&status=${webDownFlag ? "web" : "channels"
        }`;
      location.replace(maintenancePageUrl);
    }

    // redirect if user is not on maintenance page
    else if (
      (channelsDownFlag !== undefined || webDownFlag !== undefined) &&
      window.location.pathname !== "/maintenance.aspx"
    ) {
      location.replace(maintenancePageUrl);
    }

    // if user is on maintenance page fill in data from LD
    else if (
      (channelsDownFlag !== undefined || webDownFlag !== undefined) &&
      window.location.pathname === "/maintenance.aspx"
    ) {
      $(".maintenance-error__title").html(maintenancePageData.title);
      $(".maintenance-error__desc").html(
        channelsDownFlag !== undefined
          ? maintenancePageData.bodyChannelsDown
          : maintenancePageData.bodyWebDown
      );
      $(".maintenance-error__footer").html(
        channelsDownFlag !== undefined
          ? maintenancePageData.footerChannelsDown
          : maintenancePageData.footerWebDown
      );
    }
  };

  // Check for Show Favorites Flag --> [FF-SHOW-FAVORITES]
  this.HideFavorites = function (changes) {
    let favoritesFlag = client.variation(FF_SHOW_FAVORITES, false);
    let hideBestSellersFlag = client.variation(FF_BEST_SELLERS_ENABLED, false);
    if (favoritesFlag) {
      $("#my-favorites").removeClass('d-none');
      $('#favoritetab').removeClass('d-none');
      $('#BestSeller,.bestseller').removeClass('isVisible');
      $("#my-favorites").addClass('isVisible');
      $(".slider__favorite").show();
      $(
        "#homePageNew > main > div > div:nth-child(1) > div:nth-child(5) > a"
      ).show();
      if ($(".favorites-carousel").length) {
        $('#favoritetab').addClass('isActiveTab');
        $(".favorites-carousel").slick("unslick");
        $("#bestSellertab").removeClass('isActiveTab');
        $(".gridTitle--bottom").removeClass('d-none');
        $('#bottomViewAll').show();
        SlickRender();
      }
      if ($('#num-favorites').val() != 0) {
        $("#favorbestseller").removeClass('d-none');
      }
    } else if (!favoritesFlag) {
      $("#my-favorites").addClass('d-none');
      $('#favoritetab').addClass('d-none');
      $('#bottomViewAll').hide()
      if ($('#num-bestsellers').val() != 0 && !$('#BestSeller,.bestseller').hasClass('d-none')) {
        $('#BestSeller,.bestseller').addClass('isVisible');
        $("#bestSellertab").addClass('isActiveTab');
      }
      if ($('#num-bestsellers').val() != 0 && $('#BestSeller,.bestseller').hasClass('d-none')) {
        $("#favorbestseller").removeClass('d-none');
        $('#BestSeller,.bestseller').addClass('isVisible');
        $('#BestSeller,.bestseller').removeClass('d-none');
      }
      if ($('#num-bestsellers').val() == 0) {
        $('#BestSeller,.bestseller').addClass('d-none');
        $('#BestSeller,.bestseller').removeClass('isVisible');
      }
      $(
        "#homePageNew > main > div > div:nth-child(1) > div:nth-child(5) > a"
      ).hide();
      $(".slider__favorite").hide();
      SlickRender();
      if (!hideBestSellersFlag) {
        $("#favorbestseller").addClass('d-none');
      }
      $(".gridTitle--bottom").addClass('d-none');
    }
  };

  // Check for Vanity Code Enabled Flag --> [FF-VANITY-CODE-ENABLED]
  this.HideVanityCode = function (changes) {
    let vanityCodeEnabledFlag = client.variation(FF_VANITY_CODE_ENABLED, false);
    if (vanityCodeEnabledFlag) {
      $(".order-summary__promoCode").show();
      $(".order-summary__offerDisclaimer").show();
    } else if (!vanityCodeEnabledFlag) {
      $(".order-summary__promoCode").css("display", "none");
      $(".order-summary__offerDisclaimer").css("display", "none");
    }
  };

  // Check for Show Best Sellers Flag --> [Hide_Best_Sellers]
  this.HideBestSellers = function (changes) {
    let hideBestSellersFlag = client.variation(FF_BEST_SELLERS_ENABLED, false);
    let favoritesFlag = client.variation(FF_SHOW_FAVORITES, false);
    if (hideBestSellersFlag) {
      $("#display_tabs > div > a:last-child").show();
      $(".slider__bestseller").show();
      $("#bestSellertab").removeClass('d-none');

      if (
        $("#my-favorites").is(":visible") === false ||
        $("#Favorites").children()[0] === undefined
      ) {
        if ($('#num-bestsellers').val() != 0) {
          $("#BestSeller").removeClass('d-none');
          $('#BestSeller,.bestseller').addClass('isVisible');
          $("#bestSellertab").addClass('isActiveTab');
        }
        if ($('#favoritetab').hasClass('isActiveTab')) {
          $('#BestSeller,.bestseller').removeClass('isVisible');
          $("#bestSellertab").removeClass('isActiveTab');
        }
        if ($(".favorites-carousel").length) {
          $(".favorites-carousel").slick("unslick");
        }
      }
      if ($('#num-bestsellers').val() != 0) {
        $("#favorbestseller").removeClass('d-none')
      }
    } else if (!hideBestSellersFlag) {
      $("#bestSellertab").removeClass('isActiveTab');
      $("#bestSellertab").addClass('d-none');
      $('#BestSeller,.bestseller').removeClass('isVisible');
      if ($('#num-favorites').val() != 0 && !$('#my-favorites').hasClass('d-none')) {
        $('#my-favorites').removeClass('d-none');
        $('#my-favorites').addClass('isVisible');
        $("#favoritetab").addClass('isActiveTab');
        $('#my-favorites .gridTitle').removeClass('d-none');
      }
      if ($('#num-favorites').val() != 0 && $('#my-favorites').hasClass('d-none')) {
        $("#favorbestseller").removeClass('d-none')
      }
      $("#display_tabs > div > a:last-child").hide();
      $(".slider__bestseller").hide();
      if (!favoritesFlag) {
        $("#favorbestseller").addClass('d-none');
      }
    }
    SlickRender();

  };

  // Check for Custom Banner Flag --> [FF_ENABLE_CUSTOM_BANNER]
  this.ShowCustomBanner = function (changes) {
    // see if user is logged in
    let userLoggedInFlag =
      JSON.parse(
        ("; " + document.cookie)
          .split(`; UserProfileCacheKey=`)
          .pop()
          .split(";")[0]
      ).isLoggedIn || false;
    if (!userLoggedInFlag) return;

    // see if user is on homepage / profile / cart page
    let urlRegexArray = [
      /order-management/gi,
      /profile/gi,
      /[A-Za-z]{2}-[A-Za-z]{2}/g,
    ];
    let endOfUrl =
      window.location.pathname.split("/").pop() ||
      window.location.pathname.split("/")[1];
    let isMatch = urlRegexArray.some(function (rx) {
      return rx.test(endOfUrl);
    });
    if (!isMatch) return;

    let showCustomBannerData = client.variation(FF_ENABLE_CUSTOM_BANNER, false);
    // check if session storage value exists
    let customBannerSessionValue = sessionStorage.getItem("showFlag");
    if (!customBannerSessionValue) sessionStorage.setItem("showFlag", "true");

    let showBannerFlag =
      showCustomBannerData && showCustomBannerData.bannerFlag
        ? showCustomBannerData.bannerFlag
        : false;

    // if flag is true show banner
    if (showBannerFlag && customBannerSessionValue === "true") {
      if ($("nav").hasClass("cms")) {
        var cmsMarginTop = $(".cms .navbar").height() || 0;
        $(".cms .nav_padding").css({ "padding-top": `${cmsMarginTop}px` });
        $(".cms .defaultStoreHeader").css({ top: `${cmsMarginTop}px` });
        $(".dashboard-banner").css("margin-top", `${cmsMarginTop}px`);
      }
      $(".dashboard-banner").css(
        "background-color",
        showCustomBannerData.backgroundColor || "#CF0000"
      );
      $(".dashboard-banner__inner--text").css(
        "color",
        showCustomBannerData.textColor || "#FFF"
      );
      $(".dashboard-banner__inner--text").html(
        showCustomBannerData.bannerMessage[
        $("#scLanguageCode").val().slice(-5, 2).toLowerCase() || "en"
        ] || "An error has occurred"
      );
      $(".dashboard-banner").attr("hidden", false);
    } else if (!showBannerFlag || customBannerSessionValue === "false") {
      $(".dashboard-banner").attr("hidden", true);
    }
  };

  $(".dashboard-banner__inner--close").click(() => {
    $(".dashboard-banner").attr("hidden", true);
    sessionStorage.setItem("showFlag", "false");
  });

  // Check for Show Rewards and Deals Flag --> [FF_LOYALTY_MIGRATION]
  this.HideRewardsAndDeals = function (changes) {
    let hideRewardsAndDeals = client.variation(FF_LOYALTY_MIGRATION, false);
    if (hideRewardsAndDeals) {
      $(".in-Rewards-View").parent().hide();
      $(".earn-while-you-eat-w").parent().hide();
      $(".rewards-tracker-progress-div").parent().parent().hide();
      $(".deals").parent().hide();
      $(".row.mbRewardLnk").parent().hide();
      if (window.location.pathname.split("/").pop() == "profile") {
        //$(".rewardsArea").hide();
        $("#Rewards").hide();
      }
    } else if (!hideRewardsAndDeals) {
      $(".in-Rewards-View").parent().show();
      $(".earn-while-you-eat-w").parent().show();
      $(".rewards-tracker-progress-div").parent().parent().show();
      $(".deals").parent().show();
      if (window.location.pathname.split("/").pop() == "profile") {
        //$(".rewardsArea").show();
        $("#Rewards").show();
        $(".row.mbRewardLnk").parent().show();
      }
    }
  };

  // Check for Catering CTA Dashboard Flag --> [FF-FULFILLMENT_TYPE_CATERING]
  this.HideCateringCtaDashboard = function () {
    const cateringLdFlag = client.variation(FF_FULFILLMENT_TYPE_CATERING, false);
    const categoryCardbtnParent = document.querySelector('.cateringCard_btn');
    let categoryCardbtn;
    if (categoryCardbtnParent) {
      categoryCardbtn = categoryCardbtnParent.querySelector('button');
    }

    const handleButtonClick = (redirectUrl) => {
      engageApptentiveEvent('Order Catering', true, redirectUrl);
    };
    const getRedirectUrl = () => {
      const lang = window.orderViewModel.headerFooterLanguageCode.toString();
      const storeId = window.orderViewModel.store.id;
      return storeId
        ? `${window.location.origin}/${lang}/restaurant/${storeId}/menu?menuType=catering`
        : `${window.location.origin}/${lang}/locator`;
    };

    if (categoryCardbtnParent && categoryCardbtn) {
      const redirectUrl = cateringLdFlag ? getRedirectUrl() : categoryCardbtn.getAttribute('data-href');
      categoryCardbtn.addEventListener('click', () => handleButtonClick(redirectUrl));
    }
  };
  this.handleJoinNowToggle = function () {
    if (typeof toggleJoinNowButton === 'function') {
      toggleJoinNowButton();
    } else {
      void 0;
    }
  };
  this.toggle_CJA = function () {
    window.showCjaFlagValue = client.variation(FF_SHOW_CJA, false);
  };

  this.strikeThrough = function () {
    window.strikeThroughLD = client.variation(FF_STRIKE_THROUGH_PRICING, false);
  };
};

if (window.LDClient) {
  InitilizeLD();
  launchdarkly = new LaunchDarkly();
}
